(function () {
  'use strict';

  if (window.__mrcoolTopContentMeasurementInitialized) return;
  window.__mrcoolTopContentMeasurementInitialized = true;

  var SOURCE_PATH = '/pages/mini-split-electrical-requirements';
  var MEASUREMENT_ID = 'G-LQ3S0YX624';
  var EVENT_TIMEOUT_MS = 1500;
  var NAVIGATION_FALLBACK_MS = 1600;
  var analyticsAllowed = false;
  var privacyReady = false;
  var privacyAttempts = 0;
  var recentEmissions = new WeakMap();
  var navigationPending = false;

  var INTERACTIONS = {
    'shop-card-1': {
      href: '/collections/mrcool-5th-gen-diy-single-zone-mini-split-heat-pump',
      alias: 'collection',
      destination: 'single-zone-collection',
      eventName: 'content_link_click',
      destinationType: 'collection',
      productFamily: 'mrcool-diy-single-zone'
    },
    'shop-card-2': {
      href: '/collections/5th-gen-multi-zone',
      alias: 'collection',
      destination: 'multi-zone-collection',
      eventName: 'content_link_click',
      destinationType: 'collection',
      productFamily: 'mrcool-diy-multi-zone'
    },
    'shop-card-3': {
      href: '/pages/build-your-customized-mini-split',
      alias: 'builder',
      destination: 'multi-zone-builder',
      eventName: 'builder_start',
      destinationType: 'builder',
      productFamily: 'mrcool-diy-multi-zone',
      builderType: 'multi-zone'
    },
    'shop-card-4': {
      href: '/collections/hvac-surge-protection-electrical-components',
      alias: 'collection',
      destination: 'electrical-accessories-collection',
      eventName: 'content_link_click',
      destinationType: 'collection',
      productFamily: 'electrical-accessories'
    },
    'documentation-1': {
      href: '/pages/documentation-single-zone-mini-split-systems',
      alias: 'document',
      destination: 'single-zone-documentation',
      eventName: 'resource_click',
      destinationType: 'document',
      productFamily: 'single-zone'
    },
    'documentation-2': {
      href: '/pages/multi-zone-mini-split-documentation',
      alias: 'document',
      destination: 'multi-zone-documentation',
      eventName: 'resource_click',
      destinationType: 'document',
      productFamily: 'multi-zone'
    },
    'documentation-3': {
      href: '/pages/mrcool-product-documentation',
      alias: 'document',
      destination: 'documentation-hub',
      eventName: 'resource_click',
      destinationType: 'document',
      productFamily: 'all'
    },
    'related-guide-1': {
      href: '/pages/mini-split-btu-sizing-chart',
      alias: 'related_guide',
      destination: 'btu-sizing-chart',
      eventName: 'content_link_click',
      destinationType: 'guide',
      productFamily: 'mini-split'
    },
    'related-guide-2': {
      href: '/pages/single-zone-vs-multi-zone-mini-split',
      alias: 'related_guide',
      destination: 'single-vs-multi-zone',
      eventName: 'content_link_click',
      destinationType: 'guide',
      productFamily: 'mini-split'
    },
    'related-guide-3': {
      href: '/pages/mini-split-line-set-length-guide',
      alias: 'related_guide',
      destination: 'line-set-length-guide',
      eventName: 'content_link_click',
      destinationType: 'guide',
      productFamily: 'mini-split'
    },
    'related-guide-4': {
      href: '/pages/mini-split-installation-checklist',
      alias: 'related_guide',
      destination: 'installation-checklist',
      eventName: 'content_link_click',
      destinationType: 'guide',
      productFamily: 'mini-split'
    }
  };

  function refreshPrivacy() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    privacyReady = Boolean(
      privacy && typeof privacy.analyticsProcessingAllowed === 'function'
    );
    analyticsAllowed = Boolean(
      privacyReady && privacy.analyticsProcessingAllowed() === true
    );
  }

  function initializePrivacy() {
    privacyAttempts += 1;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      if (privacyAttempts < 20) setTimeout(initializePrivacy, 100);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) {
          privacyReady = false;
          analyticsAllowed = false;
          return;
        }
        refreshPrivacy();
      }
    );
  }

  function googleDestinationReady() {
    return (
      typeof window.gtag === 'function' &&
      Array.isArray(window.dataLayer)
    );
  }

  function matchInteraction(link) {
    var position = link.getAttribute('data-link-position');
    var interaction = INTERACTIONS[position];
    if (!interaction) return null;
    if (link.getAttribute('href') !== interaction.href) return null;
    if (link.getAttribute('data-content-event') !== interaction.alias) return null;
    if (link.getAttribute('data-destination') !== interaction.destination) return null;
    var annotatedFamily = link.getAttribute('data-product-family');
    if (annotatedFamily && annotatedFamily !== interaction.productFamily) return null;
    return interaction;
  }

  function handleClick(event) {
    if (location.pathname !== SOURCE_PATH) return;
    if (!event.target || typeof event.target.closest !== 'function') return;

    var link = event.target.closest('a[data-link-position]');
    if (!link || link.tagName !== 'A') return;
    var interaction = matchInteraction(link);
    if (!interaction) return;
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      (link.target && link.target !== '_self') ||
      link.hasAttribute('download')
    ) return;

    refreshPrivacy();

    if (!privacyReady || !analyticsAllowed) {
      return;
    }
    if (!googleDestinationReady()) return;

    if (navigationPending) {
      event.preventDefault();
      return;
    }

    var now = Date.now();
    var lastEmission = recentEmissions.get(link) || 0;
    if (now - lastEmission < 1500) {
      return;
    }
    recentEmissions.set(link, now);

    event.preventDefault();
    navigationPending = true;
    var navigationReleased = false;
    var fallbackTimer = null;

    function navigateOnce() {
      if (navigationReleased) return;
      navigationReleased = true;
      if (fallbackTimer !== null) clearTimeout(fallbackTimer);
      window.location.assign(interaction.href);
    }

    fallbackTimer = setTimeout(function () {
      navigateOnce();
    }, NAVIGATION_FALLBACK_MS);

    var parameters = {
      send_to: MEASUREMENT_ID,
      content_type: 'electrical_guide',
      destination_type: interaction.destinationType,
      link_position: link.getAttribute('data-link-position'),
      product_family: interaction.productFamily,
      event_callback: navigateOnce,
      event_timeout: EVENT_TIMEOUT_MS
    };
    if (interaction.builderType) parameters.builder_type = interaction.builderType;

    try {
      window.gtag('event', interaction.eventName, parameters);
    } catch (error) {
      navigateOnce();
      return;
    }
  }

  if (location.pathname !== SOURCE_PATH) return;

  document.addEventListener('visitorConsentCollected', refreshPrivacy);
  document.addEventListener('click', handleClick, {
    capture: true,
    passive: false
  });
  initializePrivacy();
})();
